const __WEBPACK_NAMESPACE_OBJECT__ = require("live/components/events/ui/console");